module.exports = __webpack_public_path__ + "static/media/bbond.6a97acfd.png";